<template>
  <div class="qgThreeInOne" ref="qgThreeInOne">
    <titleMod class="titleMod1">
      <span class="components_title">脱硫脱硝除尘系统实时监控
      </span>
    </titleMod>
    <sewageDeal class="part part1"></sewageDeal>
    <titleMod class="titleMod2">
      <span class="components_title">除尘系统颗粒物实时监控
      </span>
    </titleMod>
    <sewageDeal class="part part2"></sewageDeal>
    <titleMod class="titleMod3">
      <span class="components_title">污水处理厂实时监控
      </span>
    </titleMod>
    <sewageDeal class="part part3"></sewageDeal>

  </div>
</template>

<script>
import sewageDeal from "@/modules/DIYcomponents/components/3_1/sewageDeal/sewageDeal.vue";
import titleMod from "@/modules/DIYcomponents/components/componentsTools/titleMod/titleMod.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { sewageDeal, titleMod },
  props: ["matrix", "x", "y"],
  data() {
    //这里存放数据
    return {};
  },
  //计算属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    let that = this;
    let w = $(that.$refs.equipOpenTime).outerWidth();
    let h = $(that.$refs.equipOpenTime).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
  },
  //方法集合
  methods: {},
  unmounted() {},
};
</script>
<style lang="scss" scoped="scoped">
.qgThreeInOne {
  width: 910px;
  height: 790px;
  padding: 0px !important;
  .sewageDeal {
    padding: 20px;
  }
  .part {
    @include bg-box(910px, 250px, "panelView_blackBg_3_1.png");
    position: relative;
  }
  .part2,
  .part3 {
    margin-top: 20px;
  }
  .titleMod {
    position: absolute;
    z-index: 2;
    top: 20px;
    left: 20px;
  }
  .titleMod1 {
    top: 20px;
    left: 20px;
  }

  .titleMod2 {
    top: 290px;
    left: 20px;
  }

  .titleMod3 {
    top: 560px;
    left: 20px;
  }
}
</style>
<style>
</style>
